import { CVStepAutoApplySchema } from 'schemas/cv-steps'
import { z } from 'zod'

const cVStepAutoApplyValidator = CVStepAutoApplySchema

export type ICVStepAutoApplyValidator = z.infer<typeof cVStepAutoApplyValidator>
export default cVStepAutoApplyValidator
